import { QueryClient } from '@tanstack/react-query'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 2,
      networkMode: 'offlineFirst',
      gcTime: 1000 * 60 * 60 * 24, // 24 hours — keep cache available for offline use
    },
    mutations: {
      networkMode: 'offlineFirst',
    },
  },
})
